import * as React from 'react';
import { useAnimation } from 'framer-motion';

import { PUBLISH_TERMS_SERVICE_UNAVAILABLE_REASON } from '../../../../../../constants/events';
import { listenEvent } from '../../../../../../utils';
import { Link } from '../../../../../common/Link';
import { AnimationElement } from '../../../../../common/Animation';
import { ErrorWrapper } from '../ErrorWrapper';
import { photoIcon } from '../../icons';

import { serviceErrorAnimationConfig } from '../../constants';

interface INoPhotosProps {
  serviceName: string;
  onLinkClick(): void;
}

export const NoPhotos = React.memo(function NoPhotos({ serviceName, onLinkClick }: INoPhotosProps) {
  const animationControls = useAnimation();

  listenEvent(PUBLISH_TERMS_SERVICE_UNAVAILABLE_REASON, () => animationControls.start('start'));

  return (
    <AnimationElement animate={animationControls} {...serviceErrorAnimationConfig}>
      <ErrorWrapper icon={photoIcon}>
        Добавьте <Link onClick={onLinkClick}>фото</Link>, чтобы продвинуть объявление в&nbsp;{serviceName}
      </ErrorWrapper>
    </AnimationElement>
  );
});
